<div class="modal-header m-transparent">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-header">
  <div class="d-flex justify-content-center1 text-center">
    <h3 class="modal-title">{{'SEESION_DIALOG.TITLE' | translate}}</h3>
  </div>
</div>
<div class="modal-body">
  <div class="text-center">
    <div class="d-flex justify-content-between">
      <button class="btn btn-primary  btn-border" (click)="activeModal.dismiss()">{{'SEESION_DIALOG.CANCEL' |
        translate}}</button>
      <button class="btn btn-primary" (click)="activeModal.close()">{{'SEESION_DIALOG.OK' | translate}}</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/session-dialog/session-dialog.component.html